import { render, staticRenderFns } from "./CustomerMappingsSubmitButton.vue?vue&type=template&id=e98f8d86&scoped=true&"
import script from "./CustomerMappingsSubmitButton.vue?vue&type=script&lang=js&"
export * from "./CustomerMappingsSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMappingsSubmitButton.vue?vue&type=style&index=0&id=e98f8d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98f8d86",
  null
  
)

export default component.exports